// @flow
import xws from 'api/xws/';
import qs from 'query-string';
import type { AxiosPromise } from 'axios';
import type { XWSResponse } from 'api/clients/xws';

// Constants
import { getService } from 'constants/ajax';

type RequestData = {|
  tokenId: string,
  webKey: string,
  personInfo: Object
|};

export default function updateProfileWs({
  tokenId,
  webKey,
  personInfo
}: RequestData): AxiosPromise<RequestData, XWSResponse> {
  const updateService = getService('update');
  return xws(updateService).post(
    updateService.getPath(),
    qs.stringify({
      tokenId,
      webKey,
      personInfo: JSON.stringify(personInfo)
    })
  );
}



// WEBPACK FOOTER //
// ./src/api/xws/profile/profileWs.js